import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import SportsGymnasticsIcon from '@mui/icons-material/SportsGymnastics';

// import dashDark from '../assets/images/components/dash-dark.png';

import ReactPlayer from 'react-player';



const Styles = {

  hero: {
    padding: '160px 0 80px',
    minHeight: '65vh',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
  },

  container: {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 24px',
  },

  heroContent: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: '1.1fr 0.9fr' },
    gap: '40px',
    alignItems: 'center',
  },

  heroText: {
    '& h1': {
      lineHeight: 1.2,
      fontWeight: 700,
      fontSize: '4rem',
      marginBottom: '24px',
      letterSpacing: '-1px', // O valor negativo deve ser uma string '-1px'
      lineHeight: 1.2,
    }
  },

  Body: {
    display: 'block',
    marginBlockStart: '1em',
    marginBlockEnd: '1em',
    marginInlineStart: '0px',
    marginInlineEnd: '0px',
    unicodeBidi: 'isolate',
    color: '#ffffffba',
    fontSize: '18px'
  },

  HeroAction: {
    display: 'flex',
    gap: 3,
    flexWrap: 'wrap',
  },

  btn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    padding: '30px 10px',
    borderRadius: '50px',
    fontFamily: 'var(--font - headings)',
    fontWeight: '600',
    fontSize: '0.95rem',
    cursor: 'pointer',
    border: 'none',
    whiteSpace: 'nowrap',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    transition: 'all var(--transition-smooth)',
  },

  btnPrimary: {
    backgroundColor: '#A5E13B',
    color: '#000',
    boxShadow: '0 4px 20px var(--primary-glow)',
  },

  btnOutline: {
    background: 'transparent',
    color: 'var(--text-light)',
    border: '1px solid',
  },

  Gradient: {
    background: 'linear-gradient(135deg, #ffffff, #A5E13B)', // Substituí var(--primary) pela sua cor verde
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    fontWeight: 'inherit', // Para manter o peso do h2
  },

  heroVisual: {
    position: 'relative',
  },

  heroImageWrapper: {
    position: 'relative',
    borderRadius: '24px',
    overflow: 'hidden',
    boxShadow: '0 20px 50px rgba(0, 0, 0, 0.5)',
    border: '1px solid rgba(255,255,255,0.1)',
    width: '100%', // Use 100% do espaço da coluna do grid
    // Removi o maxWidth: '50%' que estava limitando e cortando!

    '& img': {
      width: '100%',
      height: 'auto', // Garante que a imagem apareça inteira
      display: 'block',
      objectFit: 'cover',
    }
  }

}


const items = [
  {
    icon: <SportsGymnasticsIcon />,
    title: 'Planos individuais e empresariais',
    description:
      'Com a phorm, a saúde é para todos, por isso nos trazemos uma rede de parceiros que atendem planos individuais e empresariais com um preço JUSTO!',
  },
  {
    icon: <LocalOfferIcon />,
    title: 'Descontos e benefícios nunca são demais!',
    description:
      'Por isso que alem dos melhores parceiros temos descontos com os melhores estabelecimentos. Com a Phorm você tem mais benefícios como descontos em produtos fitness, suplementação quadras e muito mais, busque em nossa rede de parceiros e descubra!',
  },
  {
    icon: <DevicesOtherIcon />,
    title: 'Disponível em todas as plataformas',
    description:
      'A Phorm está sempre conectada a você, por isso que ela está disponível para Android e IOS, busque a gente na sua loja de aplicativos e descubra o que a Phorm pode fazer por sua saúde!',
  }
];

export default function AboutPlatform() {
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);

  const handleItemClick = (index) => {
    setSelectedItemIndex(index);
  };

  return (
    <Container id="AboutPlatform" sx={[Styles.hero]}>
      <Box sx={[Styles.container, Styles.heroContent]}>
        <Box sx={Styles.heroText}>
          <h1>
            A plataforma que {' '}
            <Box
              component="span"
              sx={Styles.Gradient}
            >
              revoluciona
            </Box> o mundo fitness!</h1>
          <Typography
            sx={Styles.Body}
          >
            Chegamos para conectar você às melhores academias. Com planos acessíveis a partir de R$ 34,90, você terá uma nova experiência em saúde e bem-estar. Flexível, rápido e 100% digital.
          </Typography>

          <Box sx={Styles.HeroAction}>
            <Button href='#AboutUS' sx={[Styles.btn, Styles.btnPrimary]}>
              COMPARE OS PLANOS
            </Button>

            <Button
              sx={[Styles.btn, Styles.btnOutline]}
              href='#AboutUS'>
              Saiba Mais
            </Button>
          </Box>
        </Box>
        <Box
          sx={Styles.heroVisual}
        >
          <Box
            sx={Styles.heroImageWrapper}>
            <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&amp;w=1170&amp;auto=format&amp;fit=crop&amp;ixlib=rb-4.1.0&amp;ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Pessoa utilizando app de fitness num ginásio moderno"></img>
          </Box>
        </Box>
      </Box>
    </Container >
  );
}


{/* Mobile */ }
{/* <Grid container item gap={1} sx={{ display: { xs: 'auto', sm: 'none' } }}>
          {items.map(({ icon, title, description }, index) => (
            <Card
              key={index}
              variant="outlined"
              component={Button}
              onClick={() => handleItemClick(index)}
              sx={{
                p: 2,
                height: 'fit-content',
                width: '100%',
                background: 'none',
                backgroundColor: selectedItemIndex === index ? 'action.selected' : undefined,
                borderColor: (theme) => {
                  if (theme.palette.mode === 'light') {
                    return selectedItemIndex === index ? 'primary.light' : 'grey.200';
                  }
                  return selectedItemIndex === index ? 'primary.dark' : 'grey.800';
                }
              }}>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  textAlign: 'left',
                  flexDirection: { xs: 'column', md: 'row' },
                  alignItems: { md: 'center' },
                  gap: 2.5
                }}>
                <Box sx={{ textTransform: 'none' }}>
                  <Typography color="text.primary" variant="body2" fontWeight="bold">
                    {title}
                  </Typography>
                  <Typography color="text.secondary" variant="body2" sx={{ my: 0.5 }}>
                    {description}
                  </Typography>
                </Box>
              </Box>
            </Card>
          ))}
        </Grid>

        <Box
          component={Card}
          variant="outlined"
          sx={{
            display: { xs: 'auto', sm: 'none' },
            mt: 4,
            width: '100%',
            height: 320
          }}>
          <ReactPlayer playing={false} width={'100%'} height='100%' url="https://youtu.be/mqeF-V6aWwA" />
        </Box> */}

{/* WEEB */ }
{/* <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
            useFlexGap
            sx={{ width: '100%', display: { xs: 'none', sm: 'flex' } }}>
            {items.map(({ icon, title, description }, index) => (
              <Card
                key={index}
                variant="outlined"
                component={Button}
                onClick={() => handleItemClick(index)}
                sx={{
                  p: 2,
                  height: 'fit-content',
                  width: '100%',
                  background: 'none',
                  backgroundColor: selectedItemIndex === index ? 'action.selected' : undefined,
                  borderColor: (theme) => {
                    if (theme.palette.mode === 'light') {
                      return selectedItemIndex === index ? 'primary.light' : 'grey.200';
                    }
                    return selectedItemIndex === index ? 'primary.dark' : 'grey.800';
                  }
                }}>
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    textAlign: 'left',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { md: 'center' },
                    gap: 2.5
                  }}>
                  <Box
                    sx={{
                      color: (theme) => {
                        if (theme.palette.mode === 'light') {
                          return selectedItemIndex === index ? 'primary.main' : 'grey.300';
                        }
                        return selectedItemIndex === index ? 'primary.main' : 'grey.700';
                      }
                    }}>
                    {icon}
                  </Box>
                  <Box sx={{ textTransform: 'none' }}>
                    <Typography color="text.primary" variant="body2" fontWeight="bold">
                      {title}
                    </Typography>
                    <Typography color="text.secondary" variant="body2" sx={{ my: 0.5 }}>
                      {description}
                    </Typography>
                  </Box>
                </Box>
              </Card>
            ))}
          </Stack> */}